import {
  MILESTONE_FIND_ALL,
  MILESTONE_SET_INITIAL_STATE,
  MILESTONE_VIEW
} from './milestoneTypes'


const initialState = {
  data: [],
  pagination: {
    currentpage: 1,
    itemcount: 0,
    pagesize: 10,
    firstpage: '',
    lastpage: '',
    nextpages: [],
    prevpages: [],
    totalpages: 0
  },

  viewResult: false
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case MILESTONE_SET_INITIAL_STATE:
      return initialState;
    case MILESTONE_FIND_ALL:
      return {
        data: action.payload.data,
        pagination: action.payload.pagination
      }
    case MILESTONE_VIEW:
    return {
      ...state,
      viewResult: action.payload.data
    }
    default: return state
  }
}

export default reducer
